import React from 'react';

import { useDesignConfig } from '../../../../config/design.context';
import { bem } from '../../../../core/design/bem';
import Images from '../../../../utils/Images';
import Hexagon from '../../../Hexagon';
import ImageIcon from '../../../ImageIcon';
import { Item } from '../variants/variant.types';
import './HexagonalItem.scss';
import { ItemConfig } from './ItemComponent';

const css = bem('HexagonalItem');

type ItemProps = {
  item: Item;
  variant: string;
  itemConfig: ItemConfig;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & Record<string, any>;

const HexagonalItem = ({ item, variant, itemConfig, style }: ItemProps): JSX.Element => {
  const design = useDesignConfig();
  const { primaryColor } = design;
  const { title, icon, url, styles } = item;
  const { iconConfig, background: defaultBackground, showIcon = true, showBackground = true } =
    itemConfig || {};

  return (
    <div className={css({ variant })} data-id={item._id} style={style}>
      <Hexagon
        // stroke="#42873f"
        // strokeWidth={5}
        to={url}
        fill={item?.background?.color || primaryColor}
        backgroundImage={
          showBackground
            ? Images.maxWidth(
                item.background?.image?.uri ? item.background?.image : defaultBackground?.image,
                600,
              )
            : undefined
        }
      />
      <div className={css('Wrapper')}>
        <div className={css('Content')}>
          {!!icon && showIcon && (
            <div className={css('Icon')}>
              <ImageIcon icon={icon} {...iconConfig} style={{ color: styles?.content?.color }} />
            </div>
          )}
          {!!title && (
            <div className={css('Title')} style={{ color: styles?.content?.color }}>
              {title}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HexagonalItem;
